export const CONFIG_STORAGE_KEY = 'microsoft-oauth-config';
